import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { metaDataService } from '../domain/services/metaDataService';
import { schemaService } from '../domain/services/schemaService';
import { eventService } from '../domain/services/eventService';

export const SEO = ({ content }) => {
  // Set state using a function to ensure it's only evaluated once.
  const [seoContent, setSeoContent] = useState(() => content);
  const contentMetaData = metaDataService.getContentMetaData(seoContent);
  const openGraphMetaImage = metaDataService.getOpenGraphMetaImage(seoContent);
  const schema = schemaService.getSchema(seoContent) || {};
  const { title } = contentMetaData;
  const language = contentMetaData.language || 'en';
  const meta = contentMetaData.meta || [];
  const link = contentMetaData.link || [];

  const onTransporterRoutePreUpdate = event => {
    setSeoContent(event.detail.content);
  };

  useEffect(() => {
    eventService.addEventListener(
      'transporterRoutePreUpdate',
      onTransporterRoutePreUpdate,
      { addFlag: false }
    );

    return () =>
      eventService.removeEventListener(
        'transporterRoutePreUpdate',
        onTransporterRoutePreUpdate
      );
  }, []);
  // The order changes "magically", we need to reverse it...
  const openGraphMetaImageMetadata = openGraphMetaImage
    .reverse()
    .map(ogImageMeta => <meta {...ogImageMeta} key={ogImageMeta} />);
  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: language,
          dir: 'ltr',
          prefix:
            'content: http://purl.org/rss/1.0/modules/content/  dc: http://purl.org/dc/terms/  foaf: http://xmlns.com/foaf/0.1/  og: http://ogp.me/ns#  rdfs: http://www.w3.org/2000/01/rdf-schema#  schema: http://schema.org/  sioc: http://rdfs.org/sioc/ns#  sioct: http://rdfs.org/sioc/types#  skos: http://www.w3.org/2004/02/skos/core#  xsd: http://www.w3.org/2001/XMLSchema# ',
          xmlns: 'http://www.w3.org/1999/xhtml',
          'xmlns:fb': 'https://www.facebook.com/2008/fbml',
          'xmlns:og': 'http://ogp.me/ns#'
        }}
        title={title}
        meta={meta}
        link={link}
        defer={false}
      >
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <Helmet>{openGraphMetaImageMetadata}</Helmet>
    </>
  );
};

SEO.propTypes = {
  content: PropTypes.objectOf(PropTypes.any).isRequired
};
